<template>

  <table id="wrapper" style="calc(100vh - 54px);">
    <tr>
      <td>

        <img width="100px" src="https://cdn-icons-png.flaticon.com/512/353/353912.png" alt="">
        <br /><br />
        <h5>Whoops, Something went wrong</h5>

      </td>
    </tr>
  </table>
</template>

<style scoped>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css";
h5 {
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.89rem;
  font-weight: 500;
}
#wrapper {
  height: calc(100vh - 54px);
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
}
#wrapper td {
  vertical-align: middle;
  text-align: center;
}
</style>

<script>
export default {
  props: ['hasError']
}
</script>
